module.exports = __webpack_public_path__ + "a2253321d0f5ad7c8517110af69a6c53.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/gef-icn-clr.png
// module id = 201
// module chunks = 0